import styled from "styled-components"
import {
    color,
    layout,
    typography,
    flexbox,
    border,
    background,
    position,
    shadow,
    grid,
    space,
} from "styled-system"

const Box = styled.div`
    ${color}
    ${layout}
    ${typography}
    ${flexbox}
    ${border}
    ${background}
    ${position}
    ${shadow}
    ${grid}
    ${space}
    box-sizing: border-box;
    display: flex;
`

export default Box
